module.exports = __webpack_public_path__ + "img/apoio-universidad-de-la-republica.47cc5905.png";